module.exports = __webpack_public_path__ + "img/atlas-logo.edcceb45.png";